import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.scss';

import apiBillingCMS from '../../../api/Billing';
import ApiAddress from '../../../api/Address';
import ApiBilling from '../../../api/Billing/billingFL';

import Text from '../../Input/Text';
import SuburbSelector from '../../Input/Selector/suburbSelector';
import LinkLang from '../../Wraps/LinkLang';
import { ReactComponent as Download } from '../../../assets/icons/icon-download.svg';

import Config, { spanish } from '../../../config/config';

const BillingForm = () => {
  const history = useHistory();
  const orderId = history.location.pathname.split('/')[4];
  const [content, setContent] = useState(null);
  const [addressInfo, setAddressInfo] = useState(null);
  const [suburbOptions, setSuburbOptions] = useState(null);
  const [rfc, setRfc] = useState('');
  const [razonSocial, setRazonSocial] = useState('');
  const [street, setStreet] = useState('');
  const [billingZipCode, setBillingZipCode] = useState('');
  const [cityValue, setCityValue] = useState('');
  const [idCity, setIdCity] = useState(null);
  const [stateValue, setStateValue] = useState('');
  const [idState, setIdState] = useState(null);
  const [idSuburb, setIdSuburb] = useState(null);
  const [success, setSuccess] = useState(false);
  const [billingNumber, setBillingNumber] = useState('');

  const getAddressInfo = async (zipCode) => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      CodigoPostal: zipCode,
    };

    try {
      const resp = await ApiAddress.getAddresInfoByZipCode(payload);
      if (resp.Codigo === 200) {
        setAddressInfo(resp.InfoDireccion);
        const suburbs = [];
        resp.InfoDireccion.map((item) =>
          suburbs.push({ IdColonia: item.IdColonia, Colonia: item.Colonia })
        );
        setSuburbOptions(suburbs);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formChangeHandler = (e) => {
    switch (e.target.id) {
      case 'rfc':
        setRfc(e.target.value);
        break;
      case 'razon':
        setRazonSocial(e.target.value);
        break;
      case 'street':
        setStreet(e.target.value);
        break;
      case 'zipCode':
        if (e.target.value.length === 5) {
          setBillingZipCode(e.target.value);
          getAddressInfo(e.target.value);
        }
        break;
      case 'billingSuburb': {
        const selectedSuburb = addressInfo.find(
          (item) => item.IdColonia.toString() === e.target.value
        );
        setCityValue(selectedSuburb.Municipio);
        setIdCity(selectedSuburb.IdMunicpio);
        setStateValue(selectedSuburb.Estado);
        setIdState(selectedSuburb.IdEstado);
        setIdSuburb(selectedSuburb.IdColonia);
        break;
      }
      default:
        setRfc('');
        setRazonSocial('');
        setStreet('');
        setBillingZipCode('');
        break;
    }
  };

  const onSubmitForm = async () => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdPedido: orderId,
      AgregarDatosFiscales: {
        fiscal_RFC: rfc,
        fiscal_Nombre: razonSocial,
        fiscal_Calle: street,
        fiscal_Estado: idState,
        fiscal_Municipio: idCity,
        fiscal_Colonia: idSuburb,
        fiscal_Codigo_Postal: billingZipCode,
      },
    };

    const resp = await ApiBilling.billOrder(payload);
    if (resp.Codigo === 200) {
      setSuccess(true);
      setBillingNumber(resp.InfoTimbrado[0].numFactura);
    }
  };

  useEffect(async () => {
    setContent(await apiBillingCMS.getContent());
  }, []);
  const hasSuburbOptions = suburbOptions?.length;
  return (
    <div className={styles.container}>
      <h2>{spanish ? content?.TitleSpanish : content?.TitleEnglish}</h2>
      <div className={styles.header}>
        <p>
          {spanish
            ? content?.YourOrderNumberSpanish
            : content?.YourOrderNumberEnglish}
        </p>
        <b>{orderId}</b>
        <LinkLang to="/billing">{spanish ? 'editar' : 'edit'}</LinkLang>
      </div>
      <div className={styles.content}>
        <form className={styles.form}>
          <h4>
            {spanish ? content?.EnterDataSpanish : content?.EnterDataEnglish}
          </h4>
          <div className={styles.field}>
            <Text
              id="rfc"
              title="RFC"
              error={undefined}
              onChange={formChangeHandler}
            />
          </div>
          <div className={styles.field}>
            <Text
              id="razon"
              title={spanish ? 'Nombre' : 'Name'}
              error={undefined}
              onChange={formChangeHandler}
            />
          </div>
          <div className={styles.field}>
            <Text
              id="street"
              title={spanish ? 'Calle' : 'Street'}
              error={undefined}
              onChange={formChangeHandler}
            />
          </div>
          <div className={styles.field}>
            <Text
              id="zipCode"
              title={spanish ? 'Código postal' : 'Zip code'}
              error={undefined}
              onChange={formChangeHandler}
            />
          </div>
          <div className={styles.field}>
            <SuburbSelector
              id="billingSuburb"
              title={spanish ? 'Colonia' : 'Suburb'}
              placeholder={
                spanish ? 'Selecciona tu colonia*' : 'Select your suburb*'
              }
              error={undefined}
              options={suburbOptions}
              onChange={formChangeHandler}
              disabled={!hasSuburbOptions}
            />
          </div>
          <div className={styles.field}>
            <Text
              id="billingCity"
              title={spanish ? 'Municipio' : 'City'}
              placeholder={cityValue}
              error={undefined}
              onChange={formChangeHandler}
              disabled
            />
          </div>
          <div className={styles.field}>
            <Text
              id="billingState"
              title={spanish ? 'Estado' : 'State'}
              placeholder={stateValue}
              error={undefined}
              onChange={formChangeHandler}
              disabled
            />
          </div>
          <div className={styles.field}>
            <Text
              title={spanish ? 'País' : 'Country'}
              error={undefined}
              placeholder="México"
              disabled
            />
          </div>
          <div className={styles.button}>
            <button
              type="button"
              className="btn btn-yellow"
              onClick={onSubmitForm}
            >
              {spanish ? content?.SubmitSpanish : content?.SubmitEnglish}
            </button>
          </div>
        </form>
        {success ? (
          <div className={styles.download}>
            <p>
              Tu factura ha sido procesada con éxito. Número de factura:{' '}
              {billingNumber}
            </p>
            <a href="/" target="_blank" rel="noopener noreferrer">
              <Download />
              <span>
                {spanish ? content?.DownloadSpanish : content?.DownloadEnglish}
              </span>
            </a>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default BillingForm;
